import { z } from 'zod';

// Schemas (source of truth) — pure validation, no transforms
export const coordinateSchema = z.object({
	x: z.number(),
	y: z.number(),
});

// Types (derived from schemas)
export type ICoordinate = z.infer<typeof coordinateSchema>;
